import React from 'react';
import { clsx } from 'clsx';

interface PeriodSelectProps {
  value: number;
  onChange: (months: number) => void;
  options?: number[];
  className?: string;
}

export const PeriodSelect: React.FC<PeriodSelectProps> = ({
  value,
  onChange,
  options = [6, 12],
  className,
}) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      aria-label="Select trend period"
      className={clsx(
        'bg-slate-800 border border-slate-700 rounded-lg px-2.5 py-1.5 text-xs text-slate-200',
        'focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500/20 transition-colors',
        className
      )}
    >
      {options.map((months) => (
        <option key={months} value={months}>
          Last {months} months
        </option>
      ))}
    </select>
  );
};
